const ShimmerCatalogue = ({ count = 6 }) => {
  return (
    <section className="sm:mt-8 mt-5 px-4 sm:px-6 animate-pulse">
      {/* Title */}
      <div className="mb-4">
        <div className="h-5 w-40 bg-slate-200 rounded mb-2"></div>
        <div className="h-4 w-56 bg-slate-200 rounded"></div>
      </div>

      {/* Horizontal Scroll Shimmer */}
      <div className="flex gap-3 overflow-x-auto pb-2">
        {[...Array(count)].map((_, i) => (
          <div
            key={i}
            className="shrink-0 rounded-lg bg-white shadow-sm w-[100px] sm:w-[190px] lg:w-[200px] p-2"
          >
            {/* Image */}
            <div className="h-20 sm:h-28 w-full bg-slate-200 rounded"></div>

            {/* Text */}
            <div className="mt-2 h-3 w-3/4 mx-auto bg-slate-200 rounded"></div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ShimmerCatalogue;